<div class="field-container">
  <div class="label-container">
    <label [for]="id" [ellipsis]="1">
      <ng-content></ng-content>
    </label>

    <span *ngIf="required" class="required" aria-hidden="true"> * </span>
  </div>

  <div class="textarea-container" (click)="focus()">
    <textarea
      #textareaEl
      [attr.aria-describedby]="errorId"
      [attr.aria-invalid]="invalid"
      [attr.aria-required]="required"
      [autocomplete]="autocomplete"
      [autofocus]="autofocus"
      [disabled]="isDisabled"
      [id]="id"
      [cols]="cols"
      [rows]="rows"
      [name]="name"
      [(ngModel)]="value"
      [readonly]="readonly"
      (input)="handleOnInput(value)"
      (blur)="handleOnTouch($event)"></textarea>
  </div>

  <div class="support-text">
    <span aria-live="assertive" class="error-text" [id]="errorId">
      <ng-content select="[slot='error']"></ng-content>
    </span>

    <span *ngIf="counter && maxLength < infinity" aria-hidden="true" class="counter">{{value?.length ?? 0}}/{{maxLength}}</span>
    <span *ngIf="counter && maxLength < infinity" aria-live="polite" class="visually-hidden">{{a11yCharactersText()}}</span>
  </div>
</div>
